function checkAvailableAnnotations(annotationsLookupTable) {
  const values = Object.values(annotationsLookupTable);
  return {
    hasXAxisAnnotations: values.some(({
      axis
    }) => axis === 'x'),
    hasYAxisAnnotations: values.some(({
      axis
    }) => axis.includes('y'))
  };
}

export { checkAvailableAnnotations };
